/* eslint-disable @typescript-eslint/no-empty-function */
export const GEOCODER_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
import { GeocoderResponse } from '~/plugins/geocoder/models/geocoder.model';
import axios, { AxiosResponse } from "axios";

export class GeocoderService {

    // AIzaSyBwtvMjEklJrK6eHpqwD7VCZewE0N1H2lI

    private static _instance: GeocoderService | null = null;

    static getInstance(): GeocoderService {
        if (!GeocoderService._instance) {
            GeocoderService._instance = new GeocoderService();
        }
        return GeocoderService._instance;
    }

    private constructor() {
    }

    search(address: string): Promise<GeocoderResponse> {
        const params = { address: address, key: 'AIzaSyBwtvMjEklJrK6eHpqwD7VCZewE0N1H2lI'};

        return axios.get<GeocoderResponse>(`${GEOCODER_URL}`, { params})
            .then((axiosResponse: AxiosResponse<GeocoderResponse>) => {
                return axiosResponse.data;
            })
    }

    searchByLocation(lat: number, lon: number): Promise<GeocoderResponse> {
        const params = { latlng: `${lat},${lon}`, key: 'AIzaSyBwtvMjEklJrK6eHpqwD7VCZewE0N1H2lI' };
        return axios.get<GeocoderResponse>(`${GEOCODER_URL}`, { params})
            .then((axiosResponse: AxiosResponse<GeocoderResponse>) => {
                return axiosResponse.data;
            })
    }
}